<template>
  <div>
    <div class="mt-4 mb-4">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="/">{{ $t('home') }}</a></li>
          <li class="breadcrumb-item"><a :href="$t('ppd-title-link')">{{ $t('ppd-title') }}</a></li>
          <li class="breadcrumb-item"><a :href="$t('building-development-title-link')">{{ $t('building-development-title') }}</a></li>
          <li class="breadcrumb-item"><a :href="$t('permit-statistics-title-link')">{{ $t('permit-statistics-title') }}</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{ $t('title') }}</li>
        </ol>
      </nav>
    </div>
    <h1 class="mb-4">{{ $t("title") }}</h1>
    
    <nav role="navigation">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <router-link to="/summary" class="nav-link" role="tab" aria-controls="summary">{{ $t('summary') }}</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/volume" class="nav-link" role="tab" aria-controls="volume">{{ $t('volume') }}</router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'BuildingPermitTemplate'
}
</script>